import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { NbaTargetTypes } from '~/app/tracking/feld-m-types';

const a5: PartialCarConfiguration = {
	combinations: [
		'trimLine',
		'equipmentPackages',
		'packages',
		'paint[bodyPaint]',
		'rims',
		'headlights',
		'interiorPackages',
		'steeringWheels',
	],
	nextBestActions: [
		{
			icon: '',
			description: 'Audi Wallbox kaufen',
			labelText: 'Audi Wallbox',
			target: '_blank',
			trackingName: NbaTargetTypes.BuyWallbox,
			url: 'https://audi.elli.eco/de-DE/shop/configurator',
		},
		{
			icon: 'send',
			description: 'Verkaufsberater kontaktieren',
			labelText: 'Verkaufsberater kontaktieren',
			target: '_blank',

			trackingName: 'contact',
			url: 'https://api.my.audi.de/form/v1/forms/brandportalfd/salesperson-de-de?apiKey=brandportal-html&embedded=false&src=conf&vmt={{carline}}&vmn={{trimline}}&vac={{audiCode}}&vcl={{carlineId}}&vft={{financeProd}}&vmy={{modelYear}}&vc=EUR&pcl=https%3A%2F%2Fwww.audi.de%3D{{audiCode}}',
		},
	],
};

const a5limo: PartialCarConfiguration = {
	...a5,
};
const a5avant: PartialCarConfiguration = {
	...a5,
};
const s5limo: PartialCarConfiguration = {
	...a5,
};
const s5avant: PartialCarConfiguration = {
	...a5,
};

export { a5avant, a5limo, s5avant, s5limo };
